import * as actionTypes from "../actionTypes";

const initialState = {
  groups: [],
  inactiveGroups: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    case actionTypes.SET_INACTIVE_GROUPS:
      return {
        ...state,
        inactiveGroups: action.payload,
      };
    default:
      return state;
  }
}

export default reducer;
